import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const ClientAuthContext = createContext(null);

export const ClientAuthProvider = ({ children }) => {
  const [client, setClient] = useState(null);

  const checkAuth = useCallback(async () => {
    if (window.location.hash?.includes("session_id=")) {
      setClient(null);
      return;
    }
    try {
      const { data } = await api.get("/auth/client/me");
      setClient(data);
    } catch {
      setClient(false);
    }
  }, []);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  const loginWithGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/portal";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const logout = async () => {
    await api.post("/auth/client/logout").catch(() => {});
    setClient(false);
  };

  return (
    <ClientAuthContext.Provider value={{ client, loginWithGoogle, logout, checkAuth, setClient }}>
      {children}
    </ClientAuthContext.Provider>
  );
};

export const useClientAuth = () => useContext(ClientAuthContext);
